var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{staticClass:"main__wrapper"},[(!_vm.isEmbeddedJourney)?_c('NavBarComponent'):_vm._e(),_c('router-view'),(!_vm.isEmbeddedJourney)?_c('FooterComponent'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }